import { render, staticRenderFns } from "./ViewActivity.vue?vue&type=template&id=696afc73"
import script from "./ViewActivity.vue?vue&type=script&lang=js"
export * from "./ViewActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports